import Icon from 'core/components/icons/Icon'
import Button from 'core/components/buttons/Button'
import React, { useEffect, useState } from 'react'
import { useRouteError } from 'react-router-dom'
import AnalyticsHelper from 'utils/AnalyticsHelper'
import { docCookies } from 'utils/docCookies'

const ErrorBoundaryRoute = () => {
  const error = useRouteError() as Error
  const [id, setId] = useState<number | null>()
  const authToken = docCookies.getItem('auth_token')

  useEffect(() => {
    if (!error?.stack) return
    const _id = new Date().getTime()
    setId(_id)
    AnalyticsHelper.trackEvent('Server Error on Dashboard', {
      stack: window?.btoa(error?.stack) ?? '',
      id: _id,
      authToken,
      pathname: window?.location?.pathname,
      search: window?.location?.search
    })
  }, [authToken, error?.stack])

  console.log({
    stack: error?.stack ?? '',
    authToken,
    pathname: window?.location?.pathname,
    search: window?.location?.search
  })

  return (
    <div className="flex justify-center items-center gap-5 w-screen h-[100vh] flex-col text-center">
      <Icon
        name="exclamation-mark"
        color="text-white"
        className="bg-dark-4 rounded-full p-1"
      />
      <h1 className="text-dark-4 m-0">Server error</h1>
      <div>
        <p>Oh no! Looks like something broke.</p>
        <p>
          Try refreshing the page and if you need more help{' '}
          <a href="mailto:support@everlance.com" className="underline">
            contact support
          </a>
        </p>
        <p>
          and reference this number <span className="text-dark-4">{id}</span>.
        </p>
      </div>
      <Button
        variant="primary"
        onClick={() => {
          window.location.assign('/dashboard')
        }}
      >
        Back to home
      </Button>
    </div>
  )
}

export default ErrorBoundaryRoute
